type Props = {
  url?: string | null;
  name?: string | null;
  size?: "sm" | "md" | "lg";
};

const sizes = { sm: 40, md: 56, lg: 72 } as const;

export function Avatar(props: Props) {
  const px = sizes[props.size ?? "md"];
  const initial = (props.name?.trim() || "?").charAt(0).toUpperCase();

  if (props.url) {
    return (
      <img
        class="avatar-img"
        src={props.url}
        alt=""
        width={px}
        height={px}
        style={{ width: `${px}px`, height: `${px}px` }}
      />
    );
  }

  return (
    <div
      class="profile-preview-avatar"
      aria-hidden="true"
      style={{ width: `${px}px`, height: `${px}px`, "font-size": `${px * 0.35}px`, margin: "0" }}
    >
      {initial}
    </div>
  );
}